import { scrollToY } from '../utils/index'

export default class ScrollNext {
  constructor (el) {
    const dest = el.closest('section').offsetHeight
    el.addEventListener('click', e => {
      scrollToY(dest, 100, 'easeInOutSine')
    })
  }
}
